
export enum LogLevel {
    DEBUG = 0,
    WARN = 1,
    ERROR = 2,
}

export class Logger {
    private static level: LogLevel = LogLevel.WARN;

    private static _log(level: LogLevel, message: string, ...optionalParams: any[]): void {
        if (level < this.level) {
            return; // Skip logging if the level is lower than the current level
        }
        const timestamp = new Date().toISOString();
        const formattedMessage = `[${timestamp}] [SelectFiWidgetSDK] ${message}`;
        
        switch (level) {
            case LogLevel.DEBUG:
                console.debug(formattedMessage, ...optionalParams);
                break;
            case LogLevel.WARN:
                console.warn(formattedMessage, ...optionalParams);
                break;
            case LogLevel.ERROR:
                console.error(formattedMessage, ...optionalParams);
                break;
        }
    }

    public static setLevel(level: LogLevel): void {
        this.level = level;
    }

    public static debug(message: string, ...optionalParams: any[]): void {
        Logger._log(LogLevel.DEBUG, message, ...optionalParams);
    }

    public static warn(message: string, ...optionalParams: any[]): void {
        Logger._log(LogLevel.WARN, message, ...optionalParams);
    }

    public static error(message: string, ...optionalParams: any[]): void {
        Logger._log(LogLevel.ERROR, message, ...optionalParams);
    }
}

// In the future, we can implement remote logging with DataDog RUM or similar services